import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import { NOTIFICATION_API_URL } from 'modules/profile/notifications/api/notification-center'
import { NotificationSettingApiInterface } from 'modules/profile/notifications/types/notification-settings-interface'

export const useNotificationSettings = () => {
  const { user } = useUser()
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    NotificationSettingApiInterface
  >({
    method: RequestMethodsEnum.get,
    afterFetch: data =>
      data.map(notificationSetting => ({
        ...notificationSetting,
        id: notificationSetting.eventType,
      })),
  })

  const { data: notificationSettings, mutate } = useSWR<NotificationSettingApiInterface>(() => {
    if (user) {
      return `${NOTIFICATION_API_URL}/subscriptions`
    }
    return null
  }, fetcher)

  return { notificationSettings, isFetching, mutate }
}
